import PropTypes from 'prop-types';

import {Autocomplete, TextField} from "@mui/material";
import InputBase from "../InputBase";
import GF from "../../../../../lib/utils/GF";

class InputSearchDropDown extends InputBase {

  constructor(props) {
    super(props);
    this.state.selectedOption = this.props.defaultValue || null;
  }

  onChange = (event, option) => {
    if (option) {
      this.state.selectedOption = option;
      this.props.onChange(event, this._id, option);
    }
  }

  getValue() {
    return this.state.selectedOption
  }

  render() {
    return <Autocomplete disableClearable={GF.getValue(this.props.disableClearable, false)}
      defaultValue={this.state.selectedOption}
      size={this.props.size}
      options={this.props.children}
      onChange={this.onChange}
      fullWidth disablePortal
      renderInput={(params) => <TextField {...params} label={this.props.labelElement}/>}/>
  }
}

InputSearchDropDown.propTypes = {
  labelElement: PropTypes.string,
  helpTextElement: PropTypes.string,
  defaultValue: PropTypes.any,
  onChange: PropTypes.func,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  disableClearable: PropTypes.bool
}
export default InputSearchDropDown;
